import * as urlUtils from 'utils/Url';


export function getPathControlSubscriptions(qs={}) {
  return urlUtils.appendQueryString(`/control/subscriptions`, qs);
}
